class Notebook extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      ingredient: '[data-ingredient]',
      ingredientData: '[data-ingredient-data]',
      ingredientDataContainer: '[data-ingredient-data-container]',
      ingredientDataContainerOuter: '[data-ingredient-data-container-outer]',
      ingredientDataMobile: '[data-ingredient-data-mobile]',
      ingredientItem: '[data-ingredient-item]',
      ingredientsBlock: '[data-ingredients-block]',
      navBtn: '[data-notebook-nav-btn]',
      notebookGoToTop: '[data-notebook-go-to-top]',
      noMatches: '[data-no-matches]',
      search: '[data-search]',
      searchClear: '[data-search-clear]'
    };

    this.classes = {
      active: 'active',
      hidden: 'hide'
    };

    this.data = {
      colorValue: 'colorValue',
      ingredient: 'ingredient',
      ingredientData: 'ingredientData',
      ingredientDataMobile: 'ingredientDataMobile',
      ingredientValue: 'ingredientValue'
    };
    
    this.cache = {};
    
    this._cacheSelectors();
    this._initEvents();
    this._initGoToTop();
    
  }

  _cacheSelectors() {
    this.cache = {
      $ingredient: this.querySelectorAll(this.selectors.ingredient),
      $ingredientData: this.querySelectorAll(this.selectors.ingredientData),
      $ingredientDataContainer: this.querySelector(this.selectors.ingredientDataContainer),
      $ingredientDataContainerOuter: this.querySelector(this.selectors.ingredientDataContainerOuter),
      $ingredientItem: this.querySelectorAll(this.selectors.ingredientItem),
      $ingredientsBlock: this.querySelectorAll(this.selectors.ingredientsBlock),
      $navBtn: this.querySelectorAll(this.selectors.navBtn),
      $notebookGoToTop: this.querySelector(this.selectors.notebookGoToTop),
      $noMatches: this.querySelector(this.selectors.noMatches),
      $search: this.querySelector(this.selectors.search),
      $searchClear: this.querySelector(this.selectors.searchClear)
    }
    
  }

  _initEvents() {
    this.cache.$navBtn.forEach((nb) => nb.addEventListener('click', this._scrollToBlock.bind(this)));
    this.cache.$ingredient.forEach((i) => i.addEventListener('click', this._switchIngredientData.bind(this)));
    this.cache.$search.addEventListener('input', this._searchIngredient.bind(this));
    this.cache.$searchClear.addEventListener('click', this._clearSearch.bind(this));

  }

  _initGoToTop() {
    let bottomLimit = this.getBoundingClientRect().top + window.pageYOffset + this.offsetHeight;
    
    window.addEventListener('resize', throttle(() => {
      bottomLimit = this.getBoundingClientRect().top + window.pageYOffset + this.offsetHeight - 80;
    }, 50));

    window.addEventListener('scroll', throttle(() => {
      if (
        !this.cache.$notebookGoToTop.classList.contains(this.classes.active) &&
        window.pageYOffset > 200 &&
        this.cache.$notebookGoToTop.getBoundingClientRect().top + window.pageYOffset < bottomLimit
      ) {
        this.cache.$notebookGoToTop.classList.add(this.classes.active);  
      }
      
      if(
        this.cache.$notebookGoToTop.classList.contains(this.classes.active) &&
        (window.pageYOffset < 200 || (this.cache.$notebookGoToTop.getBoundingClientRect().top + window.pageYOffset) > bottomLimit)
      ) {
        this.cache.$notebookGoToTop.classList.remove(this.classes.active);
      }
     
    }, 50));

    this.cache.$notebookGoToTop.addEventListener('click', function() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });

  }

  _scrollToBlock(e) {
    e.preventDefault();
    let $target = e.currentTarget;
    let $block = document.getElementById($target.getAttribute('href').replace('#', ''));

    if (!$block) return;

    window.scrollTo({
      top: $block.getBoundingClientRect().top + window.pageYOffset - 150,
      behavior: 'smooth'
    });
    
  }

  _switchIngredientData(e) {
    var $target = e.currentTarget;
    var ingredient = $target.dataset[this.data.ingredient];
    var $currentData = [...this.cache.$ingredientData].find(id => id.classList.contains(this.classes.active));
    var $nextData = [...this.cache.$ingredientData].find(id => id.dataset[this.data.ingredientData] == ingredient);
    var newColorValue = $nextData.dataset[this.data.colorValue];
    
    this._switchDesktopIngredientData($currentData, $nextData, newColorValue);
    this._switchMobileIngredientData($target, $nextData, newColorValue);
    
  }

  _switchDesktopIngredientData($currentData, $nextData, newColorValue = '') {    
    if (
      !$nextData ||
      $currentData == $nextData
    ) return;

    this.cache.$ingredientDataContainerOuter.style.setProperty('background-color', newColorValue);
    
    if ($currentData) $currentData.classList.remove(this.classes.active);
    $nextData.classList.add(this.classes.active);
    
  }

  _switchMobileIngredientData($target, $nextData, newColorValue) {      
    let $currentData = this.querySelector(this.selectors.ingredientDataMobile);
    let $ingredientsBlock = $target.closest(this.selectors.ingredientsBlock);
    let $ingredientDataMobile = document.createElement('div');
    
    $ingredientDataMobile.classList.add('ingredient-data__mobile', 'border-top', 'border-bottom', 'medium-up--hide');
    $ingredientDataMobile.setAttribute('data-ingredient-data-mobile', $nextData.dataset.ingredientData || '');
    
    newColorValue ? $ingredientDataMobile.style.setProperty('background-color', newColorValue) : false

    if (!$nextData ||
        ($currentData && $nextData.dataset[this.data.ingredientData] === $currentData.dataset[this.data.ingredientDataMobile])
       ) {
      $currentData.remove(); 
      return;

    }

    $ingredientDataMobile.innerHTML = $nextData.innerHTML;

    function openNext() {
      $ingredientsBlock.insertAdjacentElement('afterend', $ingredientDataMobile);

      $ingredientDataMobile.style.setProperty('display', 'block');

      if ($ingredientDataMobile.offsetWidth || $ingredientDataMobile.offsetHeight) {
        window.scrollTo({
          top: $ingredientDataMobile.getBoundingClientRect().top + window.pageYOffset - 150,
          behavior: 'smooth'
        });
      }
    }

    if ($currentData) {
      $currentData.style.setProperty('display', 'none');
      $currentData.remove();
      openNext();
      
    } else {
      openNext();
    
    }
    
  }

  _searchIngredient(e) {
      let $target = e.currentTarget;
      let value = $target.value.trim().toLowerCase();

      if(value === '') {
        this._showAllItems();
        
      } else {

        this.cache.$ingredientItem.forEach($ii => $ii.classList.add(this.classes.hidden));
        this.cache.$ingredientsBlock.forEach($ib => $ib.classList.add(this.classes.hidden));
  
        let $foundIngredients = [...this.cache.$ingredientItem].filter($ii => $ii.dataset[this.data.ingredientValue].includes(value));

        if ($foundIngredients.length) {
          $foundIngredients
            .forEach($fi => $fi.classList.remove(this.classes.hidden));
  
          $foundIngredients
            .forEach($fi => $fi.closest(this.selectors.ingredientsBlock).classList.remove(this.classes.hidden));

          this.cache.$noMatches.classList.add(this.classes.hidden);
          
        } else {
          this.cache.$noMatches
            .classList.remove(this.classes.hidden);
          
        }

      }
    
    }

    _showAllItems() {
      this.cache.$ingredientItem.forEach($ii => $ii.classList.remove(this.classes.hidden));
      this.cache.$ingredientsBlock.forEach($ib => $ib.classList.remove(this.classes.hidden));
      this.cache.$noMatches.classList.add(this.classes.hidden);
    }

    _clearSearch() {
      this.cache.$search.value = '';
      this._showAllItems();
      
    }
  
}

customElements.define('notebook-component', Notebook);
